import * as angular from "angular";
import {IController, IScope} from "angular";

export class analysisLogsTableRowCtrl implements IController {

  id: any;
  log: any;

  /* @ngInject */
  constructor(private $serviceAnalysis, private $scope: IScope) {}

  $onInit() {
    if (this.id) {
      this.$serviceAnalysis(this.id).$bindCtrlToId(this.$scope, this, 'log', 'id');
    }
  };

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.service-analysis')
  .component('analysisLogsTableRow', {
    require:{
      logsTableCtrl: '^analysisLogsTable'
    },
    bindings: {
      id: '<',
      log: '<'
    },
    template: require('./analysis-logs-table-row.html').default,
    controller: analysisLogsTableRowCtrl
  });
